var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0816 9.94967C7.19357 10.5013 3.49859 14.6346 3.49603 19.5537V20.1659C5.62041 17.6068 8.75609 16.1025 12.0816 16.0472V19.2756C12.0817 19.744 12.3495 20.1711 12.771 20.3754C13.1925 20.5797 13.6937 20.5251 14.0614 20.235L22.0548 13.9233C22.3386 13.6997 22.5042 13.3583 22.5042 12.9969C22.5042 12.6356 22.3386 12.2942 22.0548 12.0706L14.0614 5.75892C13.6937 5.46875 13.1925 5.4142 12.771 5.61847C12.3495 5.82274 12.0817 6.24991 12.0816 6.71832V9.94967Z",
    stroke: "#353B60",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.682ce0e3.svg";
export { ForwardRef as ReactComponent };